export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_CATEGORIES_FAILURE = "FETCH_CATEGORIES_FAILURE";


export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS";
export const FETCH_PRODUCT_FAILURE= "FETCH_PRODUCT_FAILURE";


export const FETCH_SERVICE_SUCCESS = "FETCH_SERVICE_SUCCESS";
export const FETCH_SERVICE_FAILURE = "FETCH_SERVICE_FAILURE";

export const FETCH_LOGGEDUSER_SUCCESS = "FETCH_LOGGEDUSER_SUCCESS";
export const FETCH_LOGGEDUSER_FAILURE = "FETCH_LOGGEDUSER_FAILURE";

export const FETCH_CUSTOMERADDRESS_SUCCESS="FETCH_CUSTOMERADDRESS_SUCCESS";
export const FETCH_CUSTOMERADDRESS_FAILURE="FETCH_CUSTOMERADDRESS_FAILURE";

export const FETCH_COUNTS_SUCCESS = "FETCH_COUNTS_SUCCESS";
export const FETCH_COUNTS_FAILURE = "FETCH_COUNTS_FAILURE";

export const FETCH_WISHLISTDATA_SUCCESS ="FETCH_WISHLISTDATA_SUCCESS";
export const FETCH_WISHLISTDATA_FAILURES = "FETCH_WISHLISTDATA_FAILURES";

export const FETCH_POPULARSERVICE_SUCCESS = "FETCH_POPULARSERVICE_SUCCESS";
export const FETCH_POPULARSERVICE_FAILURE = "FETCH_POPULARSERVICE_FAILURE";

export const FETCH_CARTDATA_SUCCESS ="FETCH_CARTDATA_SUCCESS";
export const FETCH_CARTDATA_FAILURES = "FETCH_CARTDATA_FAILURES";

export const FETCH_PROCESSORDERS_SUCCESS = "FETCH_PROCESSORDERS_SUCCESS";
export const FETCH_PROCESSORDERS_FAILURE = "FETCH_PROCESSORDERS_FAILURE";

export const FETCH_CANCLEORDERS_SUCCESS = "FETCH_CANCLEORDERS_SUCCESS";
export const FETCH_CANCLEORDERS_FAILURE = "FETCH_CANCLEORDERS_FAILURE";

export const FETCH_REURNEDORDERS_SUCCESS = "FETCH_REURNEDORDERS_SUCCESS";
export const FETCH_REURNEDORDERS_FAILURE = "FETCH_REURNEDORDERS_FAILURE";

export const FETCH_BOOKEDSERVICES_SUCCESS = "FETCH_BOOKEDSERVICES_SUCCESS";
export const FETCH_BOOKEDSERVICES_FAILURE = "FETCH_BOOKEDSERVICES_FAILURE";

